export const buildEmptyNewIdentificationDocument = (docType, docTypeName, docId, issuingCountry ) => {
  return {
    DocumentType: docType,
    DocumentTypeName: docTypeName,
    Expires: false,
    DocumentIssueDate: '',
    DocumentID: docId,
    DocumentExpiryDate: null,
    IssuingCountry: issuingCountry,
    InScopeDocument: null,
    SelfServiceDocument: null,
  };
};